
 import { apiCall } from './apiCall';
    
    
  export default function uploadApi() {
    return {
      upload: (data,token) => apiCall('/uploadFile',data, token),
  
    };
  }
  
  